<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="StudentReqForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} {{ title }}</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :rules="[formRules.required]"
                    label="Name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="hasTemplate"
                    label="Upload File Template?"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-checkbox>
                </v-col>
                <v-col
                  :cols="hasTemplate && reupload ? 10 : 12"
                  v-if="hasTemplate && shouldShowFileInput()"
                >
                  <v-file-input
                    v-model="template_file"
                    :rules="hasTemplate ? [formRules.required] : []"
                    variant="outlined"
                    density="compact"
                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    label="File input"
                  ></v-file-input>
                </v-col>
                <v-col cols="2" v-if="hasTemplate && reupload">
                  <v-btn
                    v-if="hasTemplate && reupload"
                    icon
                    color="warning"
                    variant="text"
                    @click="undoReupload()"
                  >
                    <v-icon>mdi-undo</v-icon>Undo
                  </v-btn>
                </v-col>
                <v-col cols="12" v-if="hasTemplate && tmp_filename != null">
                  <div
                    class="d-flex justify-space-between rounded-lg pa-1"
                    style="border: 1px solid grey"
                  >
                    <div style="width: 50%">{{ tmp_filename }}</div>
                    <div style="width: 50%" class="d-flex justify-end">
                      <v-tooltip text="View" location="top">
                        <template #activator="{ props }">
                          <v-btn
                            icon
                            color="primary"
                            variant="text"
                            v-bind="props"
                            @click="viewItem()"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>

                      <v-tooltip text="Change File" location="top">
                        <template #activator="{ props }">
                          <v-btn
                            icon
                            color="warning"
                            variant="text"
                            v-bind="props"
                            @click="reuploadItem()"
                          >
                            <v-icon>mdi-upload</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    title: String,
    typeToSave: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      btnLoading: false,
      name: null,
      hasTemplate: false,
      template_file: null,
      tmp_filename: null,
      reupload: false,
      deletedFile: null,
      viewFile: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.$refs.StudentReqForm.resetValidation();
        console.log(data);
        if (data.id) {
          this.name = data.name;
          this.tmp_filename = data.template_filename;
          this.hasTemplate = data.hasTemplate == 1 ? true : false;
        } else {
          this.$refs.StudentReqForm.reset();
        }
      },
      deep: true,
    },
  },
  methods: {
    shouldShowFileInput() {
      let show = false;
      if (this.action == "Update") {
        if (this.tmp_filename == null) {
          show = true;
        }
        // show = this.reupload;
      } else {
        show = true;
      }
      return show;
    },

    initialize() {
      this.getPrograms();
    },

    reuploadItem() {
      this.reupload = true;
      this.deletedFile = this.tmp_filename;
      this.tmp_filename = null;
    },

    undoReupload() {
      this.reupload = false;
      this.tmp_filename = this.deletedFile;
      this.deletedFile = null;
    },

    viewItem() {
      let url =
        process.env.VUE_APP_SERVER +
        "/student-requirement/viewFile/" +
        this.tmp_filename;
      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);
          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    // deleteFile() {
    //   console.log(typeof this.moa_file);
    //   if (typeof this.moa_file == "string") {
    //     this.deletedFile = this.moa_file;
    //   }

    //   this.moa_file = null;
    //   this.file_desc = null;
    //   this.valid_until = null;
    // },

    async save() {
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          name: this.name,
          program_id: this.$store.state.user.program_id,
          type: this.typeToSave,
          hasTemplate: this.hasTemplate ? true : false,
        };
        let fd = new FormData();
        fd.append("data", JSON.stringify(data));

        if (this.hasTemplate) {
          let url = "/student-requirement/withFile";
          fd.append("file", this.template_file);
          this.axiosCall(url, "POST", fd).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        } else {
          let url = "/student-requirement";
          this.axiosCall(url, "POST", data).then((res) => {
            if (res.data.status == 201) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      }
    },

    async update() {
      this.btnLoading = true;
      let formValid = await this.$refs.StudentReqForm.validate();

      if (formValid.valid) {
        let data = {
          name: this.name,
          hasTemplate: this.hasTemplate,
          deletedFile: this.deletedFile,
          student_requirement_ids: JSON.stringify(
            this.data.student_requirement_ids,
          ),
        };

        if (this.hasTemplate) {
          if (this.reupload) {
            let fd = new FormData();
            fd.append("data", JSON.stringify(data));
            fd.append("file", this.template_file);
            let url = "/student-requirement/withFile/";
            this.axiosCall(url + this.data.id, "PATCH", fd).then((res) => {
              if (res.data.status == 200) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
                this.closeD();
              } else {
                this.btnLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
              }
            });
          } else {
            let url = "/student-requirement/" + this.data.id;
            this.axiosCall(url, "PATCH", data).then((res) => {
              if (res.data.status == 200) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
                this.closeD();
              } else {
                this.btnLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
              }
            });
          }
        } else {
          let fd = new FormData();
          console.log("DATA", data);
          fd.append("data", JSON.stringify(data));
          // let url = "/student-requirement/" + this.data.id;
          this.axiosCall(
            "/student-requirement/" + this.data.id,
            "PATCH",
            data,
          ).then((res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      } else {
        this.btnLoading = false;
      }
    },
    closeD() {
      eventBus.emit("closeStudentRequirementsDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
